import instanceQuery from '../../../graphql/queries/company/CompanyQuery.graphql';
import defaultQuery from '../../../graphql/queries/company/CompanyDefault.graphql';
import mutationQuery from '../../../graphql/mutations/company/CompanyMutation.graphql';
import fragment from '../../../graphql/fragments/company/CompanyFragment.graphql';
import { ALLOW_EDIT, ALLOW_VIEW } from '../../../utils/OperationPermissions';

const Company = {
  type: 'Company',
  title: 'Company Configuration',
  formTitle: 'Company Configuration',
  formUrl: '/Company/Configuration/',
  instance: instanceQuery,
  default: defaultQuery,
  update: mutationQuery,
  fragment,
  screenReference: 'COMPANY_CONFIGURATION',
  operations: ALLOW_VIEW | ALLOW_EDIT,
};

export default Company;
